<template>
	<div class="map-container">
		<div id="country-list">
            <ul class="map-list" >
				<li v-for="(item, index) in countries">
					<a v-if="item.Euro === '1'"  href="#info"
					v-bind:class="['icon flag-'+item.ID, item.isactive ? activeClass : '']"				
					v-on:click="onListClick(index, item, $event)">{{ item.Land }}</a>
				</li>
			</ul>
			<CheckBox id="Alle Länder auswählen" name="grp-all" class="hide-m"
					v-if="view === 'comparison'" 
                    v-bind:isDisabled="false"
                    v-bind:checked="allCountriesSelected"
                    action="selectAllCountries">
			</CheckBox>
		</div>
			
			<div id="europe-map" class="hide-s">
				<div class="labels">
					<div class="has-euro">Euroländer</div>
					<div class="has-no-euro">EU-Länder, die nicht<br> den Euro als Währung haben</div>
				</div>
				<div class="controls">
					<a href="#" class="icon-zoom-out" v-on:click="zoomOut($event)" title="Karte verkleinern"></a>
					<a href="#" class="icon-zoom-in" v-on:click="zoomIn($event)" title="Karte vergrößern"></a>
				</div>
			</div>
	</div>
</template>


<script>

	let d3 = require ('d3');
	let topojson = require ('topojson');

	export default 
	{
		name: 'map-view',
		props: ['countries', 'view', 'selectedCountry', 'allCountriesSelected'],
		components: {
	      CheckBox : require ('../../components/check-box/CheckBox.vue')  
	    },
		mounted : function() 
		{
			d3.json(this.dataUrl, function(error, europe) {
				this.countries.forEach(function(el, i) {
					this.countryList[el.ID] = {
						'id': i,
						'land': el.Land,
						'euro': el.Euro
					}
				}.bind(this))

				this.drawMap(error, europe)

            	EventBus.$emit('loaded', 'map')

			}.bind(this))
		},

		methods:
		{
			/**
				emit set country after list click
			*/
			onListClick: function(index, item, e) 
			{
				// e.preventDefault()
				EventBus.$emit('setCountry', index)
			},

			zoomIn: function(e) {
				e.preventDefault()
				let svg = d3.select("#europe-map svg")
				svg.transition()
			    	.duration(500)
			      	.call( this.zoom.scaleBy, 2 ) 
			},

			zoomOut: function(e) {
				e.preventDefault()
				let svg = d3.select("#europe-map svg")
				svg.transition()
			    	.duration(500)
			      	.call( this.zoom.scaleBy, 0.5 )
			},

			/**
				check country has euro
			*/
			hasCountryEuro: function(d) 
			{
				let cKey = d.properties.iso_a2.toLowerCase(),
					hasEuro = -1

				if (this.countryList[cKey] && this.countryList[cKey].euro === '1')
					hasEuro = 1
				else if ( this.countryList[cKey] && this.countryList[cKey].euro === '0' )
					hasEuro = 0

				return hasEuro
			},

			/**
				show tooltip and set country name
			*/
			showTooltip: function(cId) {

				this.tooltip = (this.tooltip) ? this.tooltip : d3.select("body").append("div")
				this.tooltip.attr("class", "tooltip")

				let tip = "<h5 id=\"tooltip\"" + cId +"'>" + this.countryList[cId].land + "</h5>"

		    	this.tooltip.html(tip)
		        	.style("left", (d3.event.pageX + 20) + "px")
		        	.style("top", (d3.event.pageY - 20) + "px")

		        this.tooltip.classed('is-active', true)
			},

			/**
				hide tooltip
			*/
			hideTooltip: function() {
				this.tooltip.classed('is-active', false)
			},

			/**
				draw map with geojsoa data
			*/			
			drawMap: function(error, europe) {

				let that = this,
					width = d3.select('#country-list').clientWidth,
					height = d3.select('#country-list').clientHeight,
					// width = 200,
					// height= 200,
					svg = d3.select("#europe-map").append("svg")
						.attr("width", width)
						.attr("height", height),
				 	projection = d3.geoMercator()
					   	.center([60,52])
					    .scale(320),
				   	ppath = d3.geoPath().projection(projection)

    			this.zoom = d3.zoom()
			    	.scaleExtent([1, 8])
					.on("zoom", zoomed)

		    	this.g = svg.append("g")

		    	this.g.selectAll("path")
		    	.data(topojson.feature(europe, europe.objects['map.geo']).features)
		    	.enter()
		    	.append("path")
		    	.attr("class", function(d) {

		    		let cId = d.properties.iso_a2.toLowerCase(),
		    				cl = 'land cId-' + cId

		    		// set default 
		    		if (this.selectedCountry.ID === cId)
		    			cl += ' is-active'

						if (this.hasCountryEuro(d) === 1)
							cl += ' euro-land'
						else if (this.hasCountryEuro(d) === 0)
							cl += ' no-euro-land'

						return cl
		    	}.bind(this))

		    	// increase stoke for small countries 
		    	.style("stroke", function(d) { 
		    		let cId = d.properties.iso_a2.toLowerCase()
                	if (this.smallCountries.indexOf(cId) >= 0)
			    		return 'transparent';
                }.bind(this))

                .style("stroke-width", function(d) {
			    	let cId = d.properties.iso_a2.toLowerCase()
                	if (this.smallCountries.indexOf(cId) >= 0)
                		return '10px';
                }.bind(this))
		    
		    	.attr("d", ppath)

		        .on("mouseover", function (d) {
			    	let cId = d.properties.iso_a2.toLowerCase()
					if (this.countryList[cId]) 
						this.showTooltip( cId )

		        }.bind(this))

		        .on("mouseout", function (d) {
		        	let cId = d.properties.iso_a2.toLowerCase()
					if (this.countryList[cId])
			        	this.hideTooltip()
		        }.bind(this))

		        .on("click touchstart", function (d) {
					let cId = d.properties.iso_a2.toLowerCase()
		        	if (this.hasCountryEuro(d) === 1 )
						EventBus.$emit('setCountry', this.countryList[cId].id)
		        }.bind(this))


				let w = that.$el.querySelector('#europe-map').clientWidth,
				h = that.$el.querySelector('#europe-map').clientHeight

				// let w = 300,
					// h = 300

				let gg = this.g

		        function zoomed() {

					// set translate limits
					if (d3.event.transform.x > 0 ) 
					 	d3.event.transform.x = 0

					if ( (d3.event.transform.k * w ) + d3.event.transform.x  < w ) 
					 	d3.event.transform.x = (d3.event.transform.k * w - w) * -1

					if (d3.event.transform.y > 0 )
					 	d3.event.transform.y = 0

					if ( (d3.event.transform.k * h ) + d3.event.transform.y  < h ) 
					 	d3.event.transform.y = (d3.event.transform.k * h - h) * -1

				  	gg.attr("transform", d3.event.transform)
				}

				let map = this.$el.querySelector('#europe-map')

				EventBus.$on('action', function(data) {
      				if (data.action === 'showView' && map.offsetParent !== null)
						svg.transition()
			      			.duration(500)
			      			.call( this.zoom.transform, d3.zoomIdentity ) 
				}.bind(this));

		    	svg.call(this.zoom)
			}
		},
		computed: {
		},
		watch: {
	      data: {
	        handler: function (val, oldVal) {
	          d3.selectAll('.land').classed('is-active', false);
	        },
	        deep: false
	      },
	      selectedCountry: {
	        handler: function (val, oldVal) {
	        	// console.log('ssss')
	        },

	        deep: false
	      }
	    },

		data: function()
		{
			return {
				dataUrl: 'data/map.json',
				activeClass: 'is-active',
				mapData: [],
				tooltip: '',
				countryList: {},
				smallCountries : ['mt', 'cy', 'lu']
			}
		}
	}
</script>

<style lang="scss" src="./style.scss"></style>



// WEBPACK FOOTER //
// Map.vue?f2d42ea2